<template>
  <div class="mostsinger">
    <div class="comp-title ml-2">
      <div class="left">
        <h1 class="text-uppercase color-text-bold">
          <img src="../../../../static/img/comp-title.png"/>
          Ca sĩ nổi bật
        </h1>
      </div>

      <div class="right mr-2">
        <a href="/nghe-si" class="btn-viewmore color-text">Xem thêm <span class="fa fa-angle-double-right"></span></a>
      </div>
    </div>

    <div style="clear: both"></div>

    <div>
      <div id='carousel-custom' class='carousel slide' data-ride='carousel'>
        <div class='carousel-inner'>
          <div v-for="(item, i) in dataList" class='carousel-item' :class="{ 'active' : i == 0 }">
            <a :href="prefixSinger + item.id">
              <img :src="item.thumbnail" :alt="item.singer" />
              <div class="carousel-caption">
                <h3 class="text-uppercase">
                  <a href="#" class="color-white">{{ item.singer }}</a>
                </h3>
              </div>
            </a>
          </div>
        </div>

        <!-- Indicators -->
        <ol class='carousel-indicators'>
          <li v-for="(item, i) in dataList" data-target='#carousel-custom' :data-slide-to='i' :class="{ 'active' : i == 0 }">
            <img :src="item.thumbnail" :alt="item.singer" />
          </li>
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "MostSinger",
    props: {

    },
    data () {
      return {
        prefixSinger: this.settings.prefixSinger,
        dataList: [
          {
            "id": 1,
            "singer": "Đan Trường",
            "thumbnail": "https://i2.wp.com/lucloi.vn/wp-content/uploads/2019/07/1554350102-411-dan-truong-avar-1554202149-width640height480.jpg",
          },
          {
            "id": 2,
            "singer": "Lam Trường",
            "thumbnail": "https://media.doisongphapluat.com/476/2019/10/30/nha-lam-truong-o-my6.jpg",
          },
          {
            "id": 3,
            "singer": "Đàm Vĩnh Hưng",
            "thumbnail": "https://image.plo.vn/w653/Uploaded/2020/pwvouqvp/2019_10_18/dam-vinh-hung-thump_qblr.jpg",
          },
          {
            "id": 4,
            "singer": "Tuấn Hưng",
            "thumbnail": "https://giadinh.mediacdn.vn/thumb_w/640/2018/10/24/casituanhung-1-crop-15403738155161384510685.jpg",
          }
        ]
      }
    },
    created () {
    },
    methods: {
      getListSinger(){
        axios.post(api.mostSinger, {pageSize: 4})
          .then(response => {
            this.dataList = response.data.result;
          })
          .catch(e => {
            console.log("Most singer----");
            console.log(e);
          });
      }
    },
    watch: {
      "$route.path": {
        handler: "getListSinger",
        immediate: true
      }
    }
  }
</script>

<style scoped>
  #carousel-custom {
    margin: 10px auto;
    width: 100%;
  }
  #carousel-custom .carousel-inner img{
    width: 100%;
    height: 300px;
  }
  #carousel-custom .carousel-indicators {
    margin: 10px 0 0;
    overflow: hidden;
    position: static;
    text-align: left;
    white-space: nowrap;
    width: 100%;
  }
  #carousel-custom .carousel-indicators li {
    background-color: transparent;
    -webkit-border-radius: 0;
    border-radius: 0;
    display: inline-block;
    height: auto;
    margin: 0 !important;
    width: auto;
  }
  #carousel-custom .carousel-indicators li img {
    width: 86px;
    height: 86px;
    margin-right: 5px;
    display: block;
    opacity: 0.5;
  }
  #carousel-custom .carousel-indicators li.active img {
    opacity: 1;
  }
  #carousel-custom .carousel-indicators li:hover img {
    opacity: 0.75;
  }
  .carousel-caption {
    width: 100%;
    right: 0 !important;
    left: 0 !important;
    bottom: 0 !important;
    background-color: rgba(0, 0, 0, 0.5);
    padding-top: 0.7rem !important;
    padding-bottom: 0.3rem !important;
  }
  .carousel-caption h3{
    font-size: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/wap/MostSinger.vue